// App.js
import React, { useEffect } from "react";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	useLocation,
	useNavigate,
} from "react-router-dom";
import { UserProvider } from "./components/UserContext";

//PROVEEDORES - CONTEXT
import { ProovedorData } from "./components/providers/ProovedorData";
import { ProveedorVisita } from "./components/providers/ProveedorVisita";

// import { CompanyProvider } from "./components/CompanyContext";
import { Ejemplo } from "./pages/ejemplo";
import { CompanyAssignedProvider } from "./components/CompanyAssignedContext";
/* hosming */
import { Error404 } from "./pages/error404";
import { AuthPage } from "./components/AuthPage";
import { EjemploPdf } from "./pages/ejemploPdf";
import { NavbarHosming } from "./components/NavbarHosming";
import { Main_Page } from "./pages/Hosming/Main_Page";
/* visitas */
import { Jhimbo_visitas } from "./pages/empresa_uno/jhimbo";
import { Navbar_Empresa_Usuarios } from "./components/empresa/privado/Menu Navbar/Navbar_Empresa_Usuarios";
import { queryClient } from "./queryClient";
import { CompanyVisitProvider } from "./components/Company_visitContext";

/* super usuario */
// import { NavbarSa } from "./components/superAdmin_comp/navbarSa";
import { LoginSuperAdmin } from "./pages/superAdmin/loginSa";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import SearchResults from "./pages/Hosming/SearchResults";

import "react-toastify/dist/ReactToastify.css";
import { NavbarEmpresa } from "./components/empresa_uno_comp/NavbarEmpresa";
import { ProveedorCompany } from "./components/providers/ProveedorCompany";
import Gradient1 from "./svg/Gradient1";
import SendAccess from "./pages/Hosming/SendAccess";
import NavbarUser from "./components/Navbar/NavbarUser";

// Cambia el color de fondo según la ruta
function BodyColorChanger() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const current_location = location.pathname;

		if (localStorage.getItem('token') && current_location == '/login') return navigate('/');

		document.body.style.backgroundColor =
			current_location === "/login" ||
				current_location === "/register" ||
				current_location === "/loginAdmin" ||
				current_location.startsWith("/administrador/")
				? "#212529"
				: "#f5f6f7";

		return () => {
			document.body.style.backgroundColor = "";
		};
	}, [location]);

	return null;
}

function App() {
	return (
		<Router>
			<BodyColorChanger />
			<ToastContainer closeOnClick={true} />
			<Routes>
				{/* Rutas públicas */}
				<Route path="/error404" element={<Error404 />} />

				{/* <Route path="/ejemplo" element={<Ejemplo />} />
						<Route path="/ejemploPdf" element={<EjemploPdf />} />*/}
				<Route path="/loginAdmin" element={<LoginSuperAdmin />} />

				{/* Rutas protegidas */}
				{/* <Route
						path="/administrador/:sub_direc/:subSection"
						element={<NavbarSa />}
					/> */}

				<Route
					path="/*"
					element={
						<ProovedorData>
							<Gradient1 />
							<Routes>
								<Route path="/login" element={<AuthPage />} />
								<Route path="/send-access" element={<SendAccess />} />
								{/* Visitas públicas */}
								<Route
									path="/company/:view"
									element={
										<ProveedorVisita>
											<Jhimbo_visitas />
										</ProveedorVisita>
									}
								/>

								{/* Empresas privadas */}
								<Route
									path="administrar/:main_direc/:sub_direc/:nit"
									element={
										<ProveedorCompany>
											<NavbarEmpresa />
										</ProveedorCompany>
									}
								/>

								<Route
									path="user/:main_direc/:view?"
									element={
										<NavbarUser />
									}
								/>

								<Route
									path="/:main_direc?/:sub_direc?"
									element={
										<NavbarHosming />
									}
								/>
							</Routes>
						</ProovedorData>
					}
				/>
			</Routes>
		</Router>
	);
}

export default App;

{/* <QueryClientProvider client={queryClient}>
			
	</QueryClientProvider> */}